import styled, { css } from 'styled-components'
import { CounterProps } from './interface'

export const TextAreaBox = styled.div<CounterProps>`
  ${({ error }) =>
    error
      ? css`
          textarea {
            border: 1px solid ${({ theme }) => theme.palette.danger100} !important;
          }
        `
      : ''}
`

export const Counter = styled.div<CounterProps>`
  font-size: ${({ theme }) => theme.fontSize.xxxs};
  color: ${({ theme }) => theme.colors.text02};
  float: right;
  margin-top: -20px;
  margin-right: ${({ theme }) => theme.space.md};
  position: relative;
  z-index: 1;

  ${({ error }) =>
    error &&
    css`
      color: ${({ theme }) => theme.colors.uiError};
    `}
`
